// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sputnik__VerifyCodeModal-prompt__EQq0e{margin-bottom:var(--tri-space-500)}`, "",{"version":3,"sources":["webpack://./src/components/VerifyPhoneNumber/VerifyCodeModal/styles.module.scss"],"names":[],"mappings":"AACE,wCACE,kCAAA","sourcesContent":[".VerifyCodeModal {\n  &-prompt {\n    margin-bottom: var(--tri-space-500);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"VerifyCodeModal-prompt": `sputnik__VerifyCodeModal-prompt__EQq0e`
};
export default ___CSS_LOADER_EXPORT___;
